import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import './style.scss';

const Buttons = ({
  value,
  values,
  update,
  hasNullDefault,
  className,
  filter,
}) => (
  <Grid role="radiogroup" aria-label="Seleziona il raggio di estensione" className={`csa-btns ${className}`}>
    {values.map((option) => (
      <GridItem
        role="radio"
        aria-checked={option.value === value}
        tabIndex={0}
        key={`${filter}-${option.label}`}
        onClick={() => update(option.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') update(option.value); }}
        behavior={hasNullDefault ? 'fixed' : ''}
        className={`csa-btns__mpbtn pr--s pl--s tp-s--s tp-w--m tp-a--c c-txt--f0 is-clickable${option.value === value ? ' sel' : ''}`}
      >
        {option.icon || option.label}
      </GridItem>
    ))}
  </Grid>
);

export default memo(Buttons);

Buttons.propTypes = {
  value: PropTypes.string,
  values: PropTypes.instanceOf(Object),
  update: PropTypes.func,
  className: PropTypes.string,
  hasNullDefault: PropTypes.bool,
  filter: PropTypes.string.isRequired,
};

Buttons.defaultProps = {
  value: '',
  values: {},
  update: () => {},
  className: '',
  hasNullDefault: false,
};
